import config from "@/../config";

export default class BaseService {
  defaultHeaders;
  accessToken;
  ApiBaseUrl = config.value("VUE_APP_WEBAPI");
  uriSpecific = "api/v1/";

  constructor(keycloakToken, currentScope = "") {
    this.accessToken = keycloakToken;
    this.defaultHeaders = {
      authorization: `bearer ${keycloakToken}`,
      "X-Current-Scope": currentScope,
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Accept: "application/json",
    };
  }

  GetUri(apiRoute) {
    var uri = this.ApiBaseUrl;
    if (!uri.endsWith("/")) {
      uri = uri + "/";
    }
    return uri + this.uriSpecific + apiRoute;
  }

  async get(apiRoute) {
    const requestOptions = {
      method: "GET",
      headers: this.defaultHeaders,
      cache: "default",
    };
    var result = await fetch(this.GetUri(apiRoute), requestOptions);
    return result.status == 204 ? null : result.json();
  }
}
